import { Download, FileSpreadsheet, FileText, Sheet, Loader2 } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { toast } from "sonner";

// Small reusable Export dropdown. Parents plug in one or more of
// `onCsv`, `onXlsx`, `onPdf` and only those actions appear.
export default function DataExportButton({ onCsv, onXlsx, onPdf, label = "Export", testId = "data-export", disabled = false }) {
  const [busy, setBusy] = useState(null);

  const run = async (kind, handler) => {
    if (!handler) return;
    setBusy(kind);
    try {
      await handler();
    } catch (e) {
      toast.error(`Export failed: ${e?.message || "please try again"}`);
    } finally {
      setBusy(null);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2" disabled={disabled} data-testid={testId}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
          {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {onCsv && (
          <DropdownMenuItem
            onClick={() => run("csv", onCsv)}
            disabled={!!busy}
            data-testid={`${testId}-csv`}
            className="gap-2"
          >
            <FileSpreadsheet className="w-4 h-4" />
            Download CSV
          </DropdownMenuItem>
        )}
        {onXlsx && (
          <DropdownMenuItem
            onClick={() => run("xlsx", onXlsx)}
            disabled={!!busy}
            data-testid={`${testId}-xlsx`}
            className="gap-2"
          >
            <Sheet className="w-4 h-4" />
            Download Excel (.xlsx)
          </DropdownMenuItem>
        )}
        {onPdf && (
          <DropdownMenuItem
            onClick={() => run("pdf", onPdf)}
            disabled={!!busy}
            data-testid={`${testId}-pdf`}
            className="gap-2"
          >
            <FileText className="w-4 h-4" />
            Print or save PDF
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
